import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    disable?: boolean;
}

export const SelectTypeProcees = ({ idSelector, onChange, label, disable }: Props) => {

    const service = new FinanceService();

    const [id, setID] = useState(null);
    const [listaType, setListaType] = useState([]);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector);
        }
    }, [idSelector])

    useEffect(() => {
        getListaType();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getListaType = () => {
        service.getProcessTypeConstants().subscribe((resp: any) => {
            if (resp.DataBeanProperties.ObjectValue) {
                setListaType(resp.DataBeanProperties.ObjectValue);
            }
        });
    };

    return (
        <>
            <label>{label ?? ":"}</label>
            <select className="form-select" disabled={disable} value={id} onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : "";
                setValue(valor)
            }}>
                <option value={""}>...</option>
                {listaType.length > 0 &&
                    listaType.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Code} {item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}